import React from 'react';
import { connect } from 'react-redux';
import { flatten } from 'lodash';
import { Alert, Button, ListGroup } from '../ui-kit';
import moment from 'moment';
import PeriodSelector from '../../utils/forms/PeriodSelector';
import { operations as combinedSchedulesOperations } from '../../state/modules/combined-schedules';
import { operations as userOperations } from '../../state/modules/users';
import { selectors as dutyExchangeSelectors } from '../../state/modules/duty-exchanges';
import { selectors as functionSelectors } from '../../state/modules/standby-duty-functions';
import { selectors as availabilityCodeSelectors } from '../../state/modules/availability-codes';
import { operations as functionOperations } from '../../state/modules/standby-duty-functions';
import { operations as dutyExchangeOperations } from '../../state/modules/duty-exchanges';
import { operations as availabilityCodesOperations } from '../../state/modules/availability-codes';
import { selectMembershipCombinedScheduleState } from '../../state/modules/combined-schedules/selectors';
import { selectors as userSelectors } from '../../state/modules/users';
import { FormattedPeriod } from '../../utils/time';
import Loader from '../general/Loader';
import { subtractInterval } from '../../utils/schedules';
import { isEqual, orderBy } from 'lodash';
import AvailabilityCodeIcon from '../general/AvailabilityCodeIcon';
import './FormInverse.css';
import SkillIconList from '../general/SkillIconList';
const ONE_WEEK_IN_HOURS = 168;

const IntervalComponent = ({ interval, selectInterval, isIntervalSelected }) => (
  <ListGroup.Item onClick={() => selectInterval(interval)} active={isIntervalSelected(interval)}>
    <h4>
      <FormattedPeriod start={interval.start_time} end={interval.end_time} detailed={true} />
    </h4>
    <SkillIconList skills={interval.assignedFunctions} />
    <AvailabilityCodeIcon code={interval.availabilityCode} />
    <br />
    {interval.comments && <blockquote>{interval.comments}</blockquote>}
  </ListGroup.Item>
);

class FormInverse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      startTime: moment().clone().startOf('day').format(),
      endTime: moment().clone().startOf('day').add(7, 'days').format(),
      selectedInterval: null,
      errors: []
    };

    props.fetchUsers();
    props.fetchDutyExchanges(this.props.dutyExchangeId);
    this.fetchSchedules();
    props.fetchAvailabilityCodes();
    props.fetchFunctions();
  }

  fetchSchedules = () => {
    this.setState({ isLoading: true });
    this.props
      .fetchCombinedSchedules({
        id: this.props.membershipId,
        type: 'membership',
        start_time: this.state.startTime,
        end_time: this.state.endTime
      })
      .then(() => {
        this.setState({ isLoading: false });
      });
  };

  // This method will change the value of the Period Selector.
  periodChange = values => {
    this.setState({
      startTime: moment(values.start_time).format(),
      endTime: moment(values.end_time).format()
    });
  };

  originalDutyExchange = () => {
    return this.props.dutyExchanges[this.props.dutyExchangeId];
  };

  originalDutyExchangeUserName = () => {
    const exchange = this.originalDutyExchange();
    if (!exchange) return <Loader />;
    const originalDutyExchangeUser = this.props.users[exchange.user_id];
    return `${originalDutyExchangeUser.first_name} ${originalDutyExchangeUser.last_name}`;
  };

  offerableIntervals = () => {
    const membershipSchedule = this.props.combinedSchedules[this.props.membershipId];
    if (!membershipSchedule) return [];
    if (!this.originalDutyExchange()) return [];

    const onDutyIntervals = membershipSchedule.intervals.filter(
      interval =>
        // duty must start in the future
        moment().isBefore(interval.start_time) &&
        // must have a assigned function (i.e. on standby duty)
        interval.assigned_function_ids.length > 0 &&
        // must be positive standby duty
        interval.detailed_availability.standby_duty
    );

    const { start_time, end_time } = this.originalDutyExchange();

    // slice out the period of the original duty exchange. This cannot be
    // offered back
    const sliced = onDutyIntervals.map(interval => subtractInterval(interval, start_time, end_time));

    return orderBy(flatten(sliced), 'start_time');
  };

  augmentInterval = interval => {
    const assignedFunctions = interval.assigned_function_ids.map(functionId => this.props.functionsById[functionId]);

    const availabilityCode = this.props.availabilityCodesById[interval.availability_code_id] || null;
    return {
      ...interval,
      assignedFunctions,
      availabilityCode
    };
  };

  selectInterval = interval => {
    this.setState({ selectedInterval: interval });
  };

  isIntervalSelected = interval => {
    return isEqual(interval, this.state.selectedInterval);
  };

  handleRedirect = response => {
    this.setState({ errors: [] });
    const { data } = response;
    globalThis.location.replace(`/memberships/${data.membership_id}/schedule/exchanges/duty_exchanges/${data.id}`);
  };

  handleErrors = errorsArray => {
    this.setState({ errors: errorsArray });
  };

  saveExchange = () => {
    const data = {
      original_exchange_id: this.props.dutyExchangeId,
      start_time: this.state.selectedInterval.start_time,
      end_time: this.state.selectedInterval.end_time
    };
    this.props.createInverseExchange(data).then(result => {
      if (result.status == 201) {
        this.handleRedirect(result);
        return;
      }
      this.handleErrors(result.duty_exchange_intervals);
    });
  };

  render = () => {
    if (
      !this.props.usersInitialLoad ||
      !this.props.dutyExchangesInitialLoad ||
      !this.props.functionsInitialLoad ||
      !this.props.availabilityCodesInitialLoad
    )
      return <Loader />;

    const intervalList = this.offerableIntervals();
    const augmentedIntervals = intervalList.map(interval => this.augmentInterval(interval));
    // Error displayer
    return (
      <React.Fragment>
        {this.state.errors.length > 0 && (
          <Alert variant="danger">
            <ul>
              {this.state.errors.map((err, index) => (
                <li key={index}>{err}</li>
              ))}
            </ul>
          </Alert>
        )}
        <PeriodSelector
          size={'medium'}
          startTime={this.state.startTime}
          endTime={this.state.endTime}
          onChange={this.periodChange}
          defaultTimeJump={ONE_WEEK_IN_HOURS}
          horizontal={true}
        />
        <Button onClick={() => this.fetchSchedules()} variant="primary">
          {I18n.t('search')}
        </Button>
        <h4>
          <strong>
            {I18n.t('schedules.exchanges.duty_exchange.offering_to', {
              name: this.originalDutyExchangeUserName()
            })}
          </strong>
        </h4>
        <Button
          onClick={() => this.saveExchange(this.state.selectedInterval)}
          variant="success"
          disabled={!this.state.selectedInterval}
        >
          {I18n.t('schedules.exchanges.duty_exchange.offer')}
        </Button>
        <br />
        <br />
        {augmentedIntervals.length > 0 ? (
          <ListGroup>
            {augmentedIntervals.map(interval => (
              <IntervalComponent
                key={interval.start_time}
                interval={interval}
                isIntervalSelected={this.isIntervalSelected}
                selectInterval={this.selectInterval}
              />
            ))}
          </ListGroup>
        ) : (
          <p>{I18n.t('no_results_found')}</p>
        )}
        {this.state.isLoading && <Loader />}
      </React.Fragment>
    );
  };
}

const mapStateToProps = state => ({
  users: state.users.byId,
  usersInitialLoad: userSelectors.initialLoadComplete(state),
  combinedSchedules: selectMembershipCombinedScheduleState(state),
  dutyExchanges: state.dutyExchanges.byId,
  dutyExchangesInitialLoad: dutyExchangeSelectors.initialLoadComplete(state),
  availabilityCodesInitialLoad: availabilityCodeSelectors.initialLoadComplete(state),
  functionsInitialLoad: functionSelectors.initialLoadComplete(state),
  availabilityCodesById: state.availabilityCodes.byId,
  functionsById: state.standbyDutyFunctions.byId
});

const mapDispatchToProps = {
  fetchUsers: userOperations.fetch,
  fetchCombinedSchedules: combinedSchedulesOperations.fetchObjects,
  fetchAvailabilityCodes: availabilityCodesOperations.fetch,
  fetchFunctions: functionOperations.fetch,
  createInverseExchange: dutyExchangeOperations.createInverse,
  fetchDutyExchanges: dutyExchangeOperations.fetch
};

export default connect(mapStateToProps, mapDispatchToProps)(FormInverse);
